const stats = [
  { k: "+120", v: "Immobili analizzati", s: "Milano e hinterland" },
  { k: "98%", v: "Clienti soddisfatti", s: "che tornano a collaborare" },
  { k: "18", v: "Mesi max", s: "contratto transitorio" },
  { k: "10%", v: "Cedolare secca", s: "con sconto IMU" },
];

export const Stats = () => {
  return (
    <section data-testid="stats-section" className="relative bg-brand-bg py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-brand-line border border-brand-line">
          {stats.map((s) => (
            <div
              key={s.v}
              data-testid={`stat-${s.v.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-brand-bg p-8 sm:p-10 lg:p-12 flex flex-col justify-end min-h-[180px]"
            >
              <div className="font-display text-5xl sm:text-6xl lg:text-7xl font-black text-brand-ink leading-none">
                {s.k}
              </div>
              <div className="mt-5 text-sm uppercase tracking-[0.18em] font-semibold text-brand-ink">
                {s.v}
              </div>
              <div className="mt-1 text-xs text-brand-muted">{s.s}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
